import { useTheme } from '@/contexts/ThemeContext/useTheme';
import { useUser } from '@/hooks/user/useUser';
import { LanguageSwitcher } from '@/components/LanguageSwitcher/LanguageSwitcher';
import { useTranslation } from 'react-i18next';
import { FooterBody } from './FooterBody';
import { footerStrings } from './footerStrings';
import { shouldReloadForLocale } from '@/lib/locale';

/**
 * Logged-out and mid-onboarding users are pinned to the light theme by
 * ThemeProvider, so the stored `theme` alone isn't enough to pick a logo.
 */
const useDarkLogos = (signedIn: boolean) => {
    const { theme } = useTheme();
    return signedIn && theme === 'dark';
};

/** The SPA footer: the viewer-dependent parts and copy from hooks, the markup from FooterBody. */
export const Footer = () => {
    const { t } = useTranslation();
    const { user } = useUser();
    const loggedIn = Boolean(user);
    return (
        <FooterBody
            darkLogos={useDarkLogos(loggedIn)}
            loggedIn={loggedIn}
            languageSwitcher={<LanguageSwitcher />}
            strings={footerStrings(t)}
            reloadLinks={shouldReloadForLocale()}
        />
    );
};
